import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["query", "results", "personId", "selectedLabel"]

  
  disconnect() {
    if (this.abortController) this.abortController.abort()
  }

  async search() {
    const query = this.queryTarget.value.trim()
    console.log("burial person search", query)

    if (query.length < 2) {
      this.resultsTarget.innerHTML = ""
      this.personIdTarget.value = ""
      this.selectedLabelTarget.textContent = "None selected"
      return
    }

    if (this.abortController) this.abortController.abort()
    this.abortController = new AbortController()

    // const url = `${window.location.pathname}/search_people?q=${encodeURIComponent(query)}`

    // const burialId = window.location.pathname.match(/\/burials\/(\d+)/)?.[1]
    // const url = `/burials/${burialId}/search_people?q=${encodeURIComponent(query)}`

    const match = window.location.pathname.match(/\/burials\/(\d+)/)
const burialId = match ? match[1] : null

if (!burialId) {
  console.error("Could not find burial id in path:", window.location.pathname)
  return
}

const url = `/burials/${burialId}/search_people?q=${encodeURIComponent(query)}`
console.log("burial person search url", url)

    try {
      const response = await fetch(url, {
        headers: { Accept: "application/json" },
        signal: this.abortController.signal
      })

      if (!response.ok) throw new Error(`Search failed: ${response.status}`)

      const people = await response.json()
      this.renderResults(people)
    } catch (error) {
      if (error.name === "AbortError") return
      this.resultsTarget.innerHTML = `<div class="text-danger small">Search failed.</div>`
    }
  }

  renderResults(people) {
    if (!people.length) {
      this.resultsTarget.innerHTML = `<div class="text-muted small">No matches found.</div>`
      return
    }

    this.resultsTarget.innerHTML = people.map((person) => {
      const subtitleParts = [person.life_dates, person.subtitle].filter(Boolean)
      const subtitle = subtitleParts.join(" · ")

      return `
        <button type="button"
                class="list-group-item list-group-item-action text-start"
                data-action="click->burial-person-link#select"
                data-person-id="${person.id}"
                data-person-name="${this.escapeHtml(person.name)}">
          <div class="fw-semibold">${this.escapeHtml(person.name)}</div>
          ${subtitle ? `<div class="small text-muted">${this.escapeHtml(subtitle)}</div>` : ""}
        </button>
      `
    }).join("")
  }

  select(event) {
    const button = event.currentTarget
    const personId = button.dataset.personId
    const personName = button.dataset.personName

    this.personIdTarget.value = personId
    this.selectedLabelTarget.textContent = personName
  }

  escapeHtml(str) {
    return String(str)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#39;")
  }
}